import { createCanBoundTo } from '@casl/react';
import ability from '../config/Ability';

export default createCanBoundTo(ability);